const Prefix = 'loc';

export const buildURL = ({language, regionID, locationID, offset, startHour, resolution, showFavouritesOnly}) => (
    ['', language, regionID, Prefix, locationID, offset, startHour, resolution, +showFavouritesOnly, ''].map(String).join('/')
);
